module.exports = __webpack_public_path__ + "img/service.d300622a.svg";